// extracted by mini-css-extract-plugin
export default {"root":"StoreTiming_root__LTHGY","isActive":"StoreTiming_isActive__XjLgZ"};